import {
  QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULE,
  QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULES
} from '@apps-common/apis/my-monitoring/schedules'
import { QUERY_KEY_GET_UNIT_SCHEDULE, QUERY_KEY_GET_UNIT_SCHEDULES } from '@apps-common/apis/portal/schedules'
import { queryClient } from '@apps-common/lib'

export const invalidateScheduleQueries = (scheduleId?: number, unitId?: string) => {
  // my monitoring
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULE(scheduleId) })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULES(unitId) })
  // portal
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_GET_UNIT_SCHEDULE(scheduleId) })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_GET_UNIT_SCHEDULES(unitId) })
}
